import { http } from '@radical/request'

export interface LoginParams {
  username: string
  password: string
}

export interface UserInfoModel {
  username: string
  expires_at: number
}

export interface LoginResponse {
  token: string
  userInfo: UserInfoModel
}

/**
 * @description: 登录
 */
export function doLogin(params: LoginParams) {
  return http.post<LoginResponse>({
    url: '/auth/login',
    params,
  })
}

/**
 * @description: 获取用户信息
 */
export function getUserInfo() {
  return http.get<UserInfoModel>({
    url: '/auth/userinfo',
  })
}

/**
 * @description: 退出登录
 */
export function logout() {
  return http.post({
    url: '/auth/logout',
  })
}

export interface IUpdatePassword {
  oldPassword: string
  newPassword: string
}

/**
 * @description: 修改密码
 */
export function changePassword(params: IUpdatePassword) {
  return http.post({
    url: '/auth/change-password',
    params,
  })
}

/**
 * @description: 注册
 */
export interface RegisterParams {
  mail: string
  password: string
  verifycode: string
}
export function register(params: RegisterParams) {
  return http.post(
    {
      url: '/user/register',
      params,
    },
    {
      errorMessageMode: 'modal',
    },
  )
}
/**
 * @description: 发送验证码
 */
export interface VerifycodeParams {
  mail: string
}
export function senVerifycode(params: VerifycodeParams) {
  return http.post(
    {
      url: '/user/getverifycode',
      params,
    },
    {
      errorMessageMode: 'message',
    },
  )
}
/**
 * @description: 重置密码
 */
export function sendResetpwdmail(params: VerifycodeParams) {
  return http.post(
    {
      url: '/user/sendresetpwdmail',
      params,
    },
    {
      errorMessageMode: 'modal',
    },
  )
}
